import styled from "styled-components";

export const DataParseSettingsWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    padding: 20px;
    overflow: hidden;
`;

export const EditorHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const EditorTitle = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: #333;
`;

export const EditorDescription = styled.div`
    font-size: 12px;
    color: #666;
    margin-top: 4px;
`;

export const EditorToolbar = styled.div`
    display: flex;
    gap: 8px;
`;

export const EditorContainer = styled.div`
    display: flex;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    height: 600px;
`;